module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_List"
    }
  }, [_vm._v("Maps, illustrations, diagrams and photographs")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Gloss"
    }
  }, [_vm._v("Glossary of terms")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapat"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" Sir Edward Watkin’s time with the GCR")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" Sir Sam Fay’s time with the GCR")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" The Great Central Railway’s financial structure and performance")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 4")])]), _vm._v(" LNER times")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 5")])]), _vm._v(" Programme of Nationalisation and planning to 1955")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 6")])]), _vm._v(" Developments from 1955 to 1959 and longer term consequences")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 7")])]), _vm._v(" The former GCR lines in the 1950s")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 8")])]), _vm._v(" Movement of coal South by rail")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 9")])]), _vm._v(" Dr Beeching and the Transport Act 1962")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 10")])]), _vm._v(" The political process of change for railways in the 1950s and 1960s")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 11")])]), _vm._v(" The former GCR lines in the 1960s")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 12")])]), _vm._v(" Accidents of timing")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 13")])]), _vm._v(" Extant/preserved/restored examples of route, architecture and traction and rolling stock of the former GCR")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapat"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("APPENDIX 1")])]), _vm._v(" Capital investment in years 1900-12")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Appendix2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("APPENDIX 2")])]), _vm._v(" Extracts from BTC Freight Charges 1957")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Appendix3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("APPENDIX 3")])]), _vm._v(" Examples of Working Timetables and their interpretation")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Appendix4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("APPENDIX 4")])]), _vm._v(" Development of competing railways in East Midlands coalfields")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("APPENDIX 5")])]), _vm._v(" Memorandum to British Railways Board dated 11 December 1963")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Appendix6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("APPENDIX 6")])]), _vm._v(" Meeting of representatives of British Railways Board and of three Regions held on 14 July 1964")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("APPENDIX 7")])]), _vm._v(" Meeting with Minister of Transport and representatives of that Ministry with representatives of BRB on 11 February 1965")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Appendix8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("APPENDIX 8")])]), _vm._v(" Meeting with Members of Parliament at BRB headquarters on 26 February 1965 and press coverage 27 February 1965")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Appendix9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("APPENDIX 9")])]), _vm._v(" Alternative passenger transport facilities following proposed closure 3/4 September 1966")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0